import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { ATAJOS, isoHoy } from './formato';

export const FiltrosPedido = ({ filtros, setFiltros }) => {
  const set = (k, v) => setFiltros((f) => ({ ...f, [k]: v }));
  return (
    <div className="space-y-4">
      <div>
        <Label className="text-xs text-slate-500">Período</Label>
        <div className="flex flex-wrap items-center gap-2 mt-1">
          <Input type="date" value={filtros.desde} max={filtros.hasta || isoHoy()} onChange={(e) => set('desde', e.target.value)} className="w-40" data-testid="expmov-desde" />
          <span className="text-slate-400 text-sm">al</span>
          <Input type="date" value={filtros.hasta} min={filtros.desde} max={isoHoy()} onChange={(e) => set('hasta', e.target.value)} className="w-40" data-testid="expmov-hasta" />
          <div className="flex flex-wrap gap-1">
            {ATAJOS.map((a) => (
              <button
                key={a.key}
                type="button"
                onClick={() => { const [d, h] = a.rango(); setFiltros((f) => ({ ...f, desde: d, hasta: h })); }}
                className="px-2.5 py-1 rounded-md text-xs bg-slate-100 text-slate-600 hover:text-blue-700 transition-colors"
                data-testid={`expmov-atajo-${a.key}`}
              >
                {a.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <div>
          <Label className="text-xs text-slate-500">Movimientos</Label>
          <Select value={filtros.sentido} onValueChange={(v) => set('sentido', v)}>
            <SelectTrigger className="mt-1" data-testid="expmov-sentido"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="TODOS">Ingresos y egresos</SelectItem>
              <SelectItem value="INGRESO">Solo ingresos</SelectItem>
              <SelectItem value="EGRESO">Solo egresos</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-xs text-slate-500">Monto mínimo</Label>
          <Input type="number" min={0} value={filtros.monto_min} onChange={(e) => set('monto_min', e.target.value)} placeholder="Sin mínimo" className="mt-1" data-testid="expmov-monto-min" />
        </div>
        <div>
          <Label className="text-xs text-slate-500">Monto máximo</Label>
          <Input type="number" min={0} value={filtros.monto_max} onChange={(e) => set('monto_max', e.target.value)} placeholder="Sin máximo" className="mt-1" data-testid="expmov-monto-max" />
        </div>
        <div>
          <Label className="text-xs text-slate-500">Contraparte (CUIT o CBU/CVU)</Label>
          <Input value={filtros.contraparte} onChange={(e) => set('contraparte', e.target.value)} placeholder="Opcional" className="mt-1 font-mono" data-testid="expmov-contraparte" />
        </div>
      </div>
    </div>
  );
};

export default FiltrosPedido;
